import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { RemoveLeadingSlashModule } from '@portal-core/project-files/pipes/remove-leading-slash/remove-leading-slash.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { FilePickerComponent } from './file-picker.component';

@NgModule({
  declarations: [
    FilePickerComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    RemoveLeadingSlashModule,
    SelfTruncatingPathModule,
    McColorModule
  ],
  exports: [
    FilePickerComponent
  ]
})
export class FilePickerModule { }
